import React, { useState } from "react";
import { PaymentElement, useStripe, useElements } from "@stripe/react-stripe-js";
import Button from "../../shared/Button/Button";
import { checkoutFormStyles as styles } from "./paymentInfo.tailwind";
import { Alert, AlertTitle } from "@mui/material";
import { useSelector } from "react-redux";
import Spinner from "../../shared/Loaders/Spinner";

const CheckoutForm = ({ return_url = window.location.href }) => {
  const stripe = useStripe();
  const elements = useElements();

  const [cardholderName, setCardholderName] = useState(""); // State for cardholder name
  const [cardholderNameError, setCardholderNameError] = useState(""); // State for cardholder name validation error
  const [message, setMessage] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [startPaymentProcess, setStartPaymentProcess] = useState(false);
  const [paymentLoader, setPaymenPreLoader] = useState(true);

  const {checkoutApiData} = useSelector(state => state.cart);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessage("");
  
    if (!stripe || !elements) {
      return; // Ensure Stripe.js has loaded
    }
  
    setCardholderNameError("");
  
    // Validate cardholder name
    if (!cardholderName.trim()) {
      setCardholderNameError("Cardholder name is required.");
      return; // Exit if validation fails
    }
  
    setIsLoading(true);

    // Call API to upload payment processing
    // if(startPaymentProcess){
    //   await startPaymentProcess();
    // }
  
    // Call Stripe's confirmPayment function with the cardholder name
    const { error } = await stripe.confirmPayment({
      elements,
      confirmParams: {
        payment_method_data: {
          billing_details: {
            name: cardholderName,
          },
        },
        return_url,
      },
      // redirect: "if_required"
    });
  
    setIsLoading(false);
  
    if (error) {
      setMessage(error.message);
    } else {
      setMessage("Payment successful!");
    }
  };
  
  return (
    <form id="payment-form" onSubmit={handleSubmit} className={styles.form}>
      {/* Show Modal */}
      {/* {isLoading && <OverlayLoader />} */}

      {/* Cardholder Name Input */}
      <div className={styles.inputContainer}>
        {checkoutApiData?.paymentResponseBody?.amount && (
          <div className="w-full flex items-baseline justify-end gap-1">
            <p className="text-[14px] font-[300] text-[#c9c9c9]">TOTAL</p>
            <p className="text-[28px] font-[500] text-primaryHeading -mt-1">${(checkoutApiData?.paymentResponseBody?.amount) / 100}</p>
            {/* Amount to be Paid: ${(checkoutApiData?.paymentResponseBody?.amount) / 100} */}
          </div>
        )}
        <label htmlFor="cardholder-name" className={styles.label}>
          Card holder full name
        </label>

        <input
          id="cardholder-name"
          type="text"
          value={cardholderName}
          onChange={(e) => setCardholderName(e.target.value)} // Update state on input change
          placeholder="Card holder full name"
          className={styles.inputField} // Adjust styling as needed
          autoComplete="off"
          autoFocus
        />
        
        {/* Display error message for cardholder name */}
        {cardholderNameError && (
          <div className="text-red-500 text-[15px] font-[300]">
            {cardholderNameError}
          </div>
        )}
      </div>

      {paymentLoader && (
        <div className="w-full flex items-center justify-center">
          <Spinner />
        </div>
      )}

      {/* Stripe Payment Element */}
      <div className={styles.paymentElement}>
        <PaymentElement
          id="payment-element"
          options={{
            layout: "tabs",
            paymentMethodOrder: ["apple_pay", "google_pay", "card"],
          }}
          onReady={() => {
            // Add any additional logic when the Payment Element is ready
            setStartPaymentProcess(true);
          }}
          onLoaderStart={() => {
            setPaymenPreLoader(false);
          }}
          onLoadError={() => {
            setPaymenPreLoader(false);
          }}
        />

        {/* Show any error or success messages */}
        {/* {message && <div  className="">{message}</div>} */}
        {message && (
          <Alert variant="filled" id="payment-message" severity="error">
            <AlertTitle>Error</AlertTitle>
            {message}
          </Alert>
        )}

        {/* Submit Button */}
        <Button
          variant="primary"
          disabled={isLoading || !stripe || !elements || !startPaymentProcess}
          id="submit"
        >
          <span id="button-text">
            {isLoading ? "Processing Payment..." : "Pay Now"}
          </span>
        </Button>
      </div>
    </form>
  );
}

export default CheckoutForm;